/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'
import PropTypes from 'prop-types'
import Collapse from '@kunukn/react-collapse'

import { Disclosure as ReactDisclosure } from '@cred/react-disclosures-sdk'

import { RATE_TABLE_FOOTER_DISCLOSURE } from './const'
import styles from './styles.module.scss'

const Disclosure = ({ slug, toggleDisclosure, isOpen }) => {
  return (
    <div className={styles.disclosureWrap}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <p
        id={RATE_TABLE_FOOTER_DISCLOSURE}
        className={`${styles.disclosureToggleBtn} bodySmall neutral500`}
        onClick={toggleDisclosure}
      >
        Disclosure
      </p>
      <Collapse isOpen={isOpen}>
        <div className="mt-16 disclaimer">
          <ReactDisclosure required={false} slug={slug} />
        </div>
      </Collapse>
    </div>
  )
}

Disclosure.propTypes = {
  slug: PropTypes.string.isRequired,
  toggleDisclosure: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
}

export default Disclosure
